<mat-card>
  <input
    (change)="onFilePicked($event)"
    class="file-upload"
    placeholder="Upload File"
    type="file"
    />
    <!-- <mat-progress-spinner mode="indeterminate" *ngIf="uploading" style="height: 50px; width:50px;"> </mat-progress-spinner> -->
    <button
      mat-button
      class="btn btn-raised btn-success btn-sm"
      color="primary"
      [disabled]="uploading || !fileObj"
      (click)="onFileUpload()"
      >
      Upload File
    </button>

    @if (errorMsg) {
      <p>Please Select file</p>
    }
  </mat-card>
